// assets
import { ScheduleOutlined } from '@ant-design/icons';

// icons
const icons = {
  ScheduleOutlined
};

// ==============================|| MENU ITEMS - DASHBOARD ||============================== //

const dashboard = {
  id: 'group-dashboard',
  title: 'Navigation',
  type: 'group',
  children: [
    {
      id: 'shifts',
      title: 'Shifts Dashboard',
      type: 'item',
      url: '/',
      icon: icons.ScheduleOutlined,
      breadcrumbs: false
    },
    {
      id: 'shifts-template',
      title: 'Shift Template',
      type: 'item',
      url: '/shifts-template',
      icon: icons.ScheduleOutlined,
      breadcrumbs: false
    }
  ]
};

export default dashboard;
